import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import Axios from "axios";

import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBTabPane,
  MDBTabContent,
  MDBNav,
  MDBNavItem,
  MDBNavLink,
  MDBBadge,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBCard,
  MDBCardBody,
  MDBCardHeader,
} from "mdbreact";

import "../css/scrollbar.css";
import useWindowDimensions from "../components/useWindowDimensions.js";

import AccessDenied from "../components/AccessDenied";

import AddEditItem from "./AddEditItem";
import ItemsTable from "./ItemsTable";

const Items = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };

  const [showPreloader, setPreloader] = useState("normal");

  const [rows, setRows] = useState([]);

  const [selRow, setSelectedRow] = useState("");

  const [modalAddEdit, showAddEdit] = useState(false);

  const toggleAddEdit = () => {
    showAddEdit(!modalAddEdit);
    loadData();
  };

  const [bRefresh, setRefresh] = useState(false);
  function refreshGrid() {
    setRefresh(!bRefresh);
    loadData();
  }

  const [isAdmin, checkAdmin] = useState(0);

  function checkAdminAccess() {
    Axios.get(
      props.apiServer +
        "/getadminaccess?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        checkAdmin(0);
        checkAdmin(res.data[0].isadmin);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadData() {
    Axios.get(props.apiServer + "/Itemslist", bearer)
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  function loadDeleteItems() {
    Axios.get(props.apiServer + "/deleteditemslist", bearer)
      .then((res) => {
        setRows(res.data);
        setPreloader("none");
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const [activeTab, setActiveTab] = useState("1");
  const toggleClassicTabs3 = (x) => {
    if (x === "1") {
      loadData();
    } else if (x === "2") {
      loadDeleteItems();
    } else {
      loadData();
    }
    setActiveTab(x);
  };

  const useMountEffect = (functionName) => useEffect(functionName, []);

  useMountEffect(checkAdminAccess);

  useMountEffect(loadData);

  if (isAdmin == 0) {
    return (
      <React.Fragment>
        <AccessDenied />
      </React.Fragment>
    );
  }

  const TabItems = (x) => {
    return (
      <React.Fragment>
        <MDBNav
          classicTabs
          className="mt-5 cloudy-knoxville-gradient brown-text small"
        >
          <MDBNavItem>
            <MDBNavLink
              to="#"
              active={activeTab === "1"}
              onClick={() => toggleClassicTabs3("1")}
              className="brown-text"
            >
              <MDBIcon fas icon="barcode" size="2x" className="brown-text" />
              <br />
              <br />
              <b>Active Items</b>
            </MDBNavLink>
          </MDBNavItem>
          <MDBNavItem>
            <MDBNavLink
              to="#"
              active={activeTab === "2"}
              onClick={() => toggleClassicTabs3("2")}
              className="brown-text"
            >
              <MDBIcon fas icon="trash-alt" size="2x" className="red-text" />
              <br />
              <br />
              <b>Deleted Items</b>
            </MDBNavLink>
          </MDBNavItem>
        </MDBNav>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      <MDBRow className="pt-5 pb-0 mb-0">
        <MDBCol md="8">
          <h6
            style={{ fontFamily: "Montserrat", fontWeight: "400" }}
            className="display-5 blue-grey-text ml-1"
          >
            {" "}
            Inventory Items
          </h6>
        </MDBCol>
        <MDBCol md="4">
          <a href="#" className="float-right" onClick={toggleAddEdit}>
            {" "}
            <MDBIcon
              icon="plus"
              size="2x"
              className="blue-text"
              title="Add New Item"
            />
          </a>
        </MDBCol>
      </MDBRow>

      <div className="classic-tabs">
        <TabItems />

        <MDBTabContent
          className="card mb-5 pt-0 pl-0 pr-0 pb-0"
          activeItem={activeTab}
        >
          <MDBTabPane tabId="1">
            {showPreloader === "normal" ? (
              <MDBRow>
                <MDBCol md="4"></MDBCol>
                <MDBCol md="4" className="text-center">
                  <br />
                  <img
                    src={process.env.PUBLIC_URL + "/loading.gif"}
                    style={{ width: "300px", textAlign: "center" }}
                    alt="loading"
                  />
                  <br />
                </MDBCol>
                <MDBCol md="4"></MDBCol>
              </MDBRow>
            ) : (
              <ItemsTable
                rows={rows}
                loadData={loadData}
                apiServer={props.apiServer}
                apiServerHybrid={props.apiServerHybrid}
                title="Active Items"
                toggleModal={toggleAddEdit}
                refreshGrid={refreshGrid}
                description="List of Active Items"
                toggleModal2={props.toggleModal2}
                quickadd="no"
                outsourced={false}
              />
            )}
          </MDBTabPane>

          <MDBTabPane tabId="2">
            {showPreloader === "normal" ? (
              <MDBRow>
                <MDBCol md="4"></MDBCol>
                <MDBCol md="4" className="text-center">
                  <br />
                  <img
                    src={process.env.PUBLIC_URL + "/loading.gif"}
                    style={{ width: "300px", textAlign: "center" }}
                    alt="loading"
                  />
                  <br />
                </MDBCol>
                <MDBCol md="4"></MDBCol>
              </MDBRow>
            ) : (
              <ItemsTable
                rows={rows}
                loadData={loadDeleteItems}
                apiServer={props.apiServer}
                apiServerHybrid={props.apiServerHybrid}
                title="Deleted Items"
                toggleModal={toggleAddEdit}
                refreshGrid={refreshGrid}
                description="List of deleted items"
                toggleModal2={props.toggleModal2}
                quickadd="no"
                outsourced={false}
              />
            )}
          </MDBTabPane>
        </MDBTabContent>
      </div>

      <MDBModal
        autoFocus={false}
        backdrop={false}
        isOpen={modalAddEdit}
        toggleModal={toggleAddEdit}
        fullHeight
        position="right"
        size="lg"
      >
        <MDBCard>
          <MDBCardHeader className="blue-gradient">
            <h5 className="h5-responsive white-text">
              <b>Add New Item</b>
            </h5>
          </MDBCardHeader>
          <MDBCardBody>
            <AddEditItem
              deployURL={props.deployURL}
              apiServer={props.apiServer}
              itemcode={""}
              apiServerHybrid={props.apiServerHybrid}
              toggleModal={toggleAddEdit}
              refreshGrid={refreshGrid}
              toggleModal2={props.toggleModal2}
              outsourced={false}
              // quickadd="yes"
            />
          </MDBCardBody>
        </MDBCard>

        {/* <AddEditDirectiveDetails toggleModal={toggleAddEdit} code={"newrecord"} directivecode={props.code}  apiServer={props.apiServer} loadDirectivesMain={props.loadDirectivesMain}/> */}
      </MDBModal>

      {/*    <ToastContainer
                        hideProgressBar={true}
                        newestOnTop={true}
                        autoClose={5000}
                    /> */}
    </React.Fragment>
  );
};

export default Items;
